(function(root)
{
	
	var app = root.$app = angular.module('natgeo', ['ngTouch', 'ngAnimate']);
	
	// A provider which lazily generates the game container once the DOM is ready and angular is booting up.
	app.provider('container', function()
	{
		var container = null;

		this.$get = ['screenManager',
		function (manager)
		{
			if ( container === null )
			{
				root.$container = container = new GameContainer( $('#mainView'), 1024, 672 );
				
				// attach the orientation change screen
				container.$fix = $('#fixorientation');
		
				// triggered when it's detected they're in portrait
				container.$screen.on('portrait', function(e)
				{
					container.$screen.hide();
					container.$fix.show();
					
					container.portrait = !(container.landscape = false);
				});
				
				// triggered when it's detected they're in landscape
				container.$screen.on('landscape', function(e)
				{			
					container.$fix.hide();
					container.$screen.show();
					
					if ( !manager.current )
					{
						manager.transition( 'splash_splash' );
					}
					if ( manager.current )
					{
						manager.current.view.find('*').scale( e.scale );
					}
					
					container.portrait = !(container.landscape = true);
				});

				// style, register resize listener, and force a resize
				container.style();
				container.register();
				container.resize();
			}
			
			return container;
			
		}];
	});
	
	// A single instance to the manager of screens
	app.value('screenManager', root.$manager = new ScreenManager());
	
	// A factory that creates screens and provides the screen with the manager and containe
	app.factory('ScreenFactory', ['screenManager', 'container', 
	function ScreenFactory(manager, container) 
	{
		return function( name, view ) 
		{
			var screen = new Screen( manager, container )
			
			screen.register( name );
			
			screen.bind( view );
			
			return screen;
		};
	}]);

	// A factory which changes levels. If the level hasn't been loaded, it's loaded
	// from the server.
	app.factory('ScreenView', ['container', 'screenManager', 'TextBubble', 'TextCircle', 'TextHexagon', 'NextButton',
	function ScreenView(container, screenManager, TextBubble, TextCircle, TextHexagon, NextButton)
	{
		var ScreenView = {

			current: null,

			loaded: {},

			index: '/index.html',

			change: function(level, screen, fact, waitTime, loadingScreen)
			{
				if ( ScreenView.current === level && screenManager.current && screenManager.current.name === screen )
				{
					return;
				}

				var loadingScreenName = loadingScreen || 'loading_level';
				var loader = screenManager.transition( loadingScreenName );
				loader.start( screen, fact, waitTime );

				if ( !level )
				{
					loader.ready();

					return;
				}

				ScreenView.current = level;

				if ( Fullscreen.is() && window.localStorage )
				{
					localStorage.setItem( 'level', level );
					localStorage.setItem( 'screen', screen );
				}
				
				if (level in ScreenView.loaded)
				{
					loader.ready();
				}
				else
				{
					$.ajax(
					{
						url: level + ScreenView.index,
						type: 'GET',
						dataType: 'html',
						success: function(data, textStatus, xhr)
						{
							var screenData = xhr.responseText;
							var loaded = $( screenData );

							ScreenView.loaded[ level ] = screenData;

							angular.element('body').injector().invoke(function($compile, $rootScope) 
							{
								var compiled = $compile( loaded )( $rootScope );

								container.$screen.append( compiled );

								ScreenView.build( compiled );

								var images = [];
								var counted = {};
								var count = 0;
								var imageID = 0;
								
								var image_on_load = function()
								{
									if (!counted[this.id])
									{
										count++;
										if (count === images.length)
										{
											loader.ready();
										}
										counted[this.id] = true;	
									}
								};

								compiled.find('img').each(function()
								{
									if (!isImageLoaded(this))
									{
										this.onload = image_on_load;
										this.onerror = image_on_load;
										this.id = imageID++;
										images.push(this);
									}
								});
							});
						}
					});
				}
			},

			build: function(base)
			{
				// initialize SVG bubbles
				base.find('.text-bubble').each(function()
				{
					TextBubble( $(this), container );
				});

				// initialize SVG circles
				base.find('.text-circle').each(function()
				{
					TextCircle( $(this), container );
				});

				// initialize SVG hexagons
				base.find('.text-hexagon').each(function()
				{
					TextHexagon( $(this), container );
				});

				// initialize SVG next buttons
				base.find('.next-button').each(function()
				{
					NextButton( $(this), container );
				});

				// Disable dragging
				base.find(':not(.draggable, .draggable-container)').on('dragstart', function()
				{
					return false;
				});
			},

			isLoaded: function(img) {
				// During the onload event, IE correctly identifies any images that
				// weren’t downloaded as not complete. Others should too. Gecko-based
				// browsers act like NS4 in that they report this incorrectly.
				if (!img.complete) {
				    return false;
				}

				// However, they do have two very useful properties: naturalWidth and
				// naturalHeight. These give the true size of the image. If it failed
				// to load, either of these should be zero.

				if (typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) {
				    return false;
				}

				// No other way of checking: assume it’s ok.
				return true;
			}
		};

		// Make $ScreenView accessible through console so calls like $ScreenView.change('level3', 'level3_build', false, 1) can be made to quickly traverse screens.
		window.$ScreenView = ScreenView;

		return ScreenView;
	}]);

	// The main controller which handles input & events outside the game container.
	app.controller('MainController', ['$scope', 'ScreenView', 'SoundEngine', 'UserProgress', 'screenManager',
	function MainController($scope, ScreenView, SoundEngine, UserProgress, screenManager)
	{
		$scope.oninit = function()
		{
			
			/**
			 * If we're in a standalone web app, restore the previous level, screen, and passcode.
			 */
			if ( Fullscreen.is() && window.localStorage && localStorage.getItem('level') )
			{
				UserProgress.loadPasscode();

				var level = localStorage.getItem( 'level' );
				var screen = localStorage.getItem( 'screen' );

				ScreenView.change( level, screen, false, 2000, 'loading_game' );
			}
			/**
			 * If a hash is given, let's assume they're cool and jump to that screen.
			 * Also prepare the sound and submarine selections.
			 * This will also listen for click events and output to the console the position of the mouse relative to the game container.
			 */
			else if ( location && location.hash === '#credits' )
			{
				// The Credit Screen is special
				ScreenView.change( false, 'credits', false, 2000, 'loading_game' );
			}
			else if ( location && location.hash.indexOf('_') !== -1 )
			{
				var screen = location.hash.substring( 1 );
				var under = screen.indexOf( '_' );
				var level = screen.substring( 0, under );

				SoundEngine.register();

				UserProgress.SubmarineBody = UserProgress.SubmarineBodies.Cylinder;
				UserProgress.SubmarineMotor = UserProgress.SubmarineMotors.Hybrid;
				UserProgress.SubmarineSensor = UserProgress.SubmarineSensors.Sonar;
				UserProgress.SubmarineEffector = UserProgress.SubmarineEffectors.Net;
				UserProgress.SubmarineController = UserProgress.SubmarineControllers.Serpentine;
				UserProgress.ExplorerRetrieval = UserProgress.ExplorerRetrievals.Claw;
				UserProgress.ExplorerLight = UserProgress.ExplorerLights.Light;

				ScreenView.change( level, screen, false, 1000, 'loading_game' );

				// Mouse Location
				$('body').click(function(e)
				{
					var corner = $('#mainView').offset();
					var relativeX = e.pageX - corner.left;
					var relativeY = e.pageY - corner.top;

					if ( window.console && !isNaN( relativeX ) )
					{
						console.log( relativeX + ', ' + relativeY );
					}
				});
			}
			else
			{
				// Otherwise, load the game as normal
				ScreenView.change('splash', 'splash_splash', true, 2000, 'loading_game');				
			}

			// Fastclick
			FastClick.attach( document.body );

			// Hide bars
			$( window ).load(function() 
			{
				// Set a timeout...
		    setTimeout(function()
		    {
		    	if ( window.scrollTo )
		    	{
		        // Hide the address bar!
		        window.scrollTo(0, 1);
		    	}
		    }, 0);
			});

			// Key Input
			Shortcuts.init();

			// Pointer-Events polyfill
			PointerEventsPolyfill.initialize({
				selector: '.clickthrough'
			});

			// Browser Detection
			if ( window.console ) {
				if ( Chrome.version() !== false ) {
					console.log( 'Chrome:', Chrome.version() );
				}
				if ( IE.version() !== false ) {
					console.log( 'IE:', IE.version() );
				}
				if ( Safari.version() !== false ) {
					console.log( 'Safari:', Safari.version() );
				}
			}
		};

		ScreenView.build( $('#mainView') );
	}]);

})(window);

